import { NormalizedCacheObject, ApolloClient } from '@apollo/client'
import Cookies from 'universal-cookie'
import { getSharedEnv } from '../src/shared/lib/env'
import { makeApolloClient as sharedMakeApolloClient } from '@scentregroup/shared/apollo-client'
import type { Auth0ContextInterface } from '@auth0/auth0-react'

interface IMakeApolloClientOptions {
  requestId?: string
  auth0?: Pick<
    Auth0ContextInterface,
    'getAccessTokenSilently' | 'getIdTokenClaims'
  > | null
  cookies?: Partial<{ [key: string]: string }>
  getSessionId?(): string
}

export function makeApolloClient({
  requestId,
  auth0,
  cookies,
  getSessionId,
}: IMakeApolloClientOptions = {}): ApolloClient<NormalizedCacheObject> {
  const urlsByVersion: Record<number, string> = {
    1: getSharedEnv('graphqlApi.v1'),
    2: getSharedEnv('graphqlApi.v2'),
  }

  return sharedMakeApolloClient({
    client: {
      name: 'checkout-client',
      version: getSharedEnv('sentry.release'),
    },
    operationLogging: process.env.NODE_ENV === 'development',
    defaultVersion: 2,
    urlsByVersion,
    requestId,
    auth0,
    cookies: new Cookies(cookies),
    getSessionId,
  })
}
